export function defineQuartzConfig(config) {
  return config;
}